import uuid from "uuid-random";
import { FINSEMBLECONFIG, getConfigurationAndCache } from "./common/windowFunctions";
const ensureEndSlash = (path) => {
    if (path.slice(-1) === "/") {
        return path;
    }
    return `${path}/`;
};
const insertAsFirstElement = (parent, child) => {
    if (parent.firstChild) {
        parent.insertBefore(child, parent.firstChild);
    }
    else {
        parent.appendChild(child);
    }
};
const injectThemeCSS = (documentRoot) => {
    if (documentRoot) {
        const cacheBuster = uuid();
        const themeCssUrl = `${ensureEndSlash(documentRoot)}assets/css/theme.css?${cacheBuster}`;
        const themeLink = document.createElement("link");
        themeLink.setAttribute("rel", "stylesheet");
        themeLink.setAttribute("type", "text/css");
        themeLink.setAttribute("href", themeCssUrl);
        insertAsFirstElement(document.body, themeLink);
    }
};
const isUIComponent = async (glue) => {
    if (!glue.windows) {
        return false;
    }
    const config = await getConfigurationAndCache(glue.windows.my());
    if (config?.customProperties?.component) {
        return true;
    }
    if (glue.windows.my()?.name.substring(0, 7) === "(Menu) ") {
        return true;
    }
    return ["custom-tray", "finsemble-decorator-window", "web-group-application"].includes(globalThis.glue42gd?.applicationName);
};
const manageThemeInHtml = async (glue) => {
    let currentTheme = null;
    if (!glue.themes) {
        return;
    }
    const attachThemeClassToHtml = (newTheme) => {
        const html = document.getElementsByTagName("html");
        if (currentTheme) {
            html[0]?.classList.remove(currentTheme.name);
        }
        currentTheme = newTheme;
        html[0]?.classList.add(currentTheme.name);
    };
    currentTheme = await glue.themes.getCurrent();
    attachThemeClassToHtml(currentTheme);
    glue.themes.onChanged((theme) => {
        attachThemeClassToHtml(theme);
    });
};
export const maybeInjectThemeCSS = async (glue) => {
    const shouldInjectTheme = await isUIComponent(glue);
    if (!shouldInjectTheme) {
        return;
    }
    const manifest = await glue.contexts.get(FINSEMBLECONFIG);
    injectThemeCSS(manifest?.finsemble?.documentRoot);
    manageThemeInHtml(glue);
};
